import React, { FC, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Skeleton, notification, useMe } from 'src/common';
import { Header } from 'src/shared';
import styles from './index.module.scss';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Paths } from '../paths';
import CompaniesList from './CompaniesList';
import UserList from './UserList';
import CompanyMembersList from './CompanyMembersList';
import Tabs from './Tabs';
import { isAdminRole } from 'src/models/users/Roles/types';
import BasicSkeleton from 'src/layouts/BasicSkeleton';

export const AdminPage: FC = () => {
  const { data: me } = useMe();
  const { t } = useTranslation();

  if (!isAdminRole(me?.company?.pricePlan)) {
    notification.error({
      message: t('Common.ACL.haveNoAccess')
    });
    return <Navigate to={Paths.HOME_PATH} />;
  }

  return (
    <Suspense fallback={<BasicSkeleton />}>
      <Header />
      <div className={styles.container}>
        <Tabs />
        <div className={styles.content}>
          <Routes>
            <Route
              path={Paths.ADMIN_PAGE_COMPANY_INFO}
              element={
                <Suspense fallback={<Skeleton active loading />}>
                  <CompanyMembersList />
                </Suspense>
              }
            />
            <Route
              path={Paths.ADMIN_PAGE_COMPANIES_LIST}
              element={
                <Suspense fallback={<Skeleton active loading />}>
                  <CompaniesList />
                </Suspense>
              }
            />
            <Route
              path={Paths.ADMIN_PAGE_USERS_LIST}
              element={
                <Suspense fallback={<Skeleton active loading />}>
                  <UserList />
                </Suspense>
              }
              index
            />
            <Route path={`*`} element={<Navigate to={`${Paths.ADMIN_PAGE}${Paths.ADMIN_PAGE_USERS_LIST}`} replace />} />
          </Routes>
        </div>
      </div>
    </Suspense>
  );
};

export default AdminPage;
